import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import { PostHogProvider } from 'posthog-js/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={"phc_uScugK03HAOZPmYZ72B2IBfpRF2zW2secJ7biDcq6D1"}
            options={{
                api_host: "https://us.i.posthog.com",
                defaults: '2025-05-24',
                capture_exceptions: true, // This enables capturing exceptions using Error Tracking
                debug: process.env.NODE_ENV === "development",
            }}
        >
            <DevSupport ComponentPreviews={ComponentPreviews}
                        useInitialHook={useInitial}
            >
                <App />
            </DevSupport>
        </PostHogProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();